"use strict";
if (!JSON.tryParse) {
  JSON.tryParse = function(str) {
    try {
      return JSON.parse(str);
    }
    catch (e) {
      return null;
    }
  }
}
